module.exports = __webpack_public_path__ + "img/maxres.95761131.png";